import React from "react";
import { Card, Row, Col } from "antd";
import './GolfDetail.less';
import * as HMS from "../../../../common/component/Index";
import moment from 'moment';
import { withTranslation } from "react-i18next";

const formatCurrency = (value) => value?.toLocaleString() || '0';
const formatDate = (date) => moment(date).format('DD/MM/YYYY');

const GolfDetail = ({ t, teeTimes, order, orderInfoGolf }) => {
    const teeTimesWithCategory = teeTimes.map((item, index) => ({
        ...item,
        key: index,
        category: "Tee Time",
        serviceType: `Golf - Tee Time ${index + 1}`,
        totalAmount: item.golfers.reduce((sum, golfer) => sum + golfer.amount, 0),
    }));

    const total = teeTimesWithCategory.reduce((sum, item) => sum + item.totalAmount, 0);
    let golferWithVoucherCount = 0;
    let totalVoucherAmount = 0;
    let totalCK = 0;
    teeTimes.forEach((booking) => {
        booking.golfers.forEach((golfer) => {
            if (golfer.voucherCode && golfer.voucherCode.trim() !== "") {
                golferWithVoucherCount++;
                totalVoucherAmount += golfer.voucherAmount;
                totalCK += golfer.amount;
            }
        });
    });
    const columns = [
        {
            title: t("orderGolf.no"),
            key: "index",
            width: '5%',
            render: (_, __, index) => index + 1,
        },
        {
            title: t("orderGolf.customerType"),
            dataIndex: "customerType",
            key: "customerType",
            width: '10%',
        },
        {
            title: t("orderGolf.customerName"),
            dataIndex: "customerName",
            key: "customerName",
            width: '25%',
        },
        {
            title: t("orderGolf.customerCode"),
            dataIndex: "customerCode",
            key: "customerCode",
            width: '10%',
        },
        {
            title: t("orderGolf.voucherCode"),
            dataIndex: "voucherCode",
            key: "voucherCode",
            width: '10%',
        },
        {
            title: t("orderGolf.voucherAmount"),
            dataIndex: "surchargeFee",
            key: "surchargeFee",
            width: '15%',
            render: formatCurrency,
        },
        {
            title: t("orderGolf.amount"),
            dataIndex: "amount",
            key: "amount",
            width: '15%',
            render: formatCurrency,
        },
    ];

    const columnsPay = [
        {
            title: t("orderGolf.no"),
            key: "index",
            width: "5%",
            render: (_, record, index) => {
                const isFirstRow = index === 0 || teeTimesWithCategory[index]?.index !== teeTimesWithCategory[index - 1]?.index;
                return isFirstRow ? record.key + 1 : '';
            },
        },
        {
            title: t("orderGolf.category"),
            dataIndex: "category",
            key: "category",
            width: '30%',
            render: (text, _, index) => {
                const isFirstRow = index === 0 || teeTimesWithCategory[index]?.category !== teeTimesWithCategory[index - 1]?.category;
                return isFirstRow ? text : '';
            },
        },
        {
            title: t("orderGolf.serviceType"),
            dataIndex: "serviceType",
            key: "serviceType",
            width: '50%',
        },
        {
            title: t("orderGolf.amount"),
            dataIndex: "totalAmount",
            key: "totalAmount",
            width: '15%',
            render: formatCurrency,
        },
    ];

    return (
        <div className="order-detail-golf">
            <h3 style={{ color: "#f90" }}>{t('orderGolf.info')}</h3>
            {teeTimes.map((teeTime, idx) => (
                <div key={idx} style={{ marginBottom: 20 }}>
                    <h4>{t('orderGolf.teeTime')} {idx + 1}</h4>
                    <Card>
                        <Row>
                            <Col span={12}>
                                <div style={{ color: 'black' }}>
                                    <strong>{t('orderGolf.infoItem')}</strong>
                                </div>
                                <ul style={{ paddingLeft: 30, color: 'black' }}>
                                    <li><strong>{t('orderGolf.date')}:</strong> {formatDate(teeTime.usingDate)}</li>
                                    <li><strong>{t('orderGolf.time')}:</strong> {teeTime.teeTime}</li>
                                    <li><strong>{t('orderGolf.golf')}:</strong> {teeTime.clubName}</li>
                                </ul>
                            </Col>
                            <Col span={12}>
                                <ul style={{ paddingLeft: 16, color: 'black' }}>
                                    <li>{t('orderGolf.courtType')}: {teeTime.courseName}</li>
                                    <li>{t('orderGolf.holes')}: {teeTime.holes}</li>
                                    <li>{t('orderGolf.teeBox')}: {teeTime.teeBox}</li>
                                    <li>{t('orderGolf.numberPlayer')}: {teeTime.numberOfGolfer}</li>
                                </ul>
                            </Col>
                        </Row>
                    </Card>

                    <HMS.ListComponent
                        dataSource={teeTime.golfers
                            .sort((a, b) => a.orderNo - b.orderNo)
                            .map((player, index) => ({ ...player, key: index }))
                        }
                        columns={columns}
                        pagination={false}
                        style={{ marginTop: 20 }}
                        bordered={false}
                    />
                </div>
            ))}

            <h3 style={{ color: "#f90" }}>{t('orderGolf.paymentInfo')}</h3>

            <HMS.ListComponent
                columns={columnsPay}
                dataSource={teeTimesWithCategory}
                pagination={false}
                bordered={false}
            />

            <div className="title-payment">
                <div className="title">{t('orderGolf.cashBeforePromotion')}</div>
                <div className="price">{formatCurrency(total)}</div>
            </div>

            <div className="title-payment-item-vc">
                <div className="title-item">{t('orderGolf.useVoucher')}</div>
                <div className="count">{t('orderGolf.countVC')}: {golferWithVoucherCount}</div>
                <div className="price">{formatCurrency(totalVoucherAmount)}</div>
            </div>

            <div className="title-payment-item">
                <div className="title-item">{t('orderGolf.surcharge')}</div>
                <div className="price">{orderInfoGolf?.totalSurchargeFee ? formatCurrency(orderInfoGolf?.totalSurchargeFee) : 0}</div>
            </div>

            <div className="title-payment-item">
                <div className="title-item">{t('orderGolf.deposit')}</div>
                <div className="price">0</div>
            </div>

            <div className="title-payment-total">
                <div className="title-item">{t('orderGolf.total')}</div>
                <div className="price">{formatCurrency((total - totalCK + order?.totalSurcharge) > 0 ? (total - totalCK + order?.totalSurcharge) : 0)}</div>
            </div>
        </div>
    );
};

export default withTranslation()(GolfDetail);
